$(function() {
// Set a Slick Slider with arrow to all devices.
  var slideArrow = {
    dots: true,
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    adaptiveHeight: true,
    prevArrow: '<div class="slide-prev"></div>',
    nextArrow: '<div class="slide-next"></div>'
  };

// Set a Slick Slider with arrow to Tablet & SmartPhone.
  var slideCardArrow = {
    dots: true,
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
    prevArrow: '<div class="slide-prev"></div>',
    nextArrow: '<div class="slide-next"></div>',
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 992,
        settings: {
          centerMode: true
        }
      }
    ]
  };

// Set a Slick Slider.
  var slide = {
    dots: true,
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerMode: true,
          centerPadding: "30%",
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

// Set a Slick Slider for Reason.
  var slideReasons = {
    dots: true,
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: "0%"
        }
      },
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          centerPadding: "0%"
        }
      }
    ]
  };

// Set a Slick Slider to Tablet & SmartPhone.
  var slideCard = {
    dots: true,
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          centerPadding: "10%"
        }
      }
    ]
  };

// Set a Slick Slider with arrow to SmartPhone.
  var slideCommercial = {
    dots: true,
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
    prevArrow: '<div class="slide-prev"></div>',
    nextArrow: '<div class="slide-next"></div>',
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 576,
        settings: {
          centerMode: true
        }
      }
    ]
  };

// Set a Slick Slider with arrow to all devices. Desktop and Tablet has thumbnails.
  var slideArrowThumbnail = {
    autoplay: true,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    adaptiveHeight: true,
    prevArrow: '<div class="slide-prev"></div>',
    nextArrow: '<div class="slide-next"></div>',
    responsive: [
      {
        breakpoint: 9999,
        settings: {
          dots: true,
          customPaging: function(slick, index) {
            // スライダーのインデックス番号に対応した画像のsrcを取得
            var targetImage = slick.$slides
              .eq(index)
              .find("img")
              .attr("src");
            // slick-dots > li の中に上記で取得した画像を設定
            return (
              '<img class="slide--search-detail__item__image--thumb" src=" ' +
              targetImage +
              ' "/>'
            );
          }
        }
      },
      {
        breakpoint: 576,
        settings: {
          dots: true
        }
      }
    ]
  };

  // Slick Slider.
  $(".js-slide--arrow").slick(slideArrow);
  $(".js-slide-card--arrow").slick(slideCardArrow);
  $(".js-slide").slick(slide);
  $(".js-slide-card").slick(slideCard);
  $(".js-slide-reason").slick(slideReasons);
  $(".js-slide-detail").slick(slideArrowThumbnail);
  $(".js-slide-commercial").slick(slideCommercial);
});
